import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Format a price: €49 for whole numbers, €49.90 for decimals */
export function formatPrice(amount: number): string {
  return amount % 1 === 0 ? `€${amount}` : `€${amount.toFixed(2)}`;
}

/** Check whether an invoice number represents a credit note (Gutschrift). */
export function isCreditNote(invoiceNumber: string): boolean {
  return invoiceNumber.endsWith('-CN');
}
